import React, { Component } from "react";
import { connect } from "react-redux";
import DialogHeader from "../common/DialogHeader";
import DialogFooter from "../common/DialogFooter";
import { Link, withRouter } from "react-router-dom";
import {
  getClientsWithoutPagination,
  getRolesListWithoutPagination,
  getSubjectList,
  addUser,
  editUser,
  switchSelectedTab,
  setUsersTab,
  addUserToastClose
} from "../actions/userActions";
import ACLService from "../../acl/services/aclService";
import Autocomplete from "../common/Autocomplete";
import getCountryList from "../assets/countryListUtility";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import {
  withStyles,
  WithStyles,
  Card,
  CardContent,
  CardActions,
  Typography,
  Modal,
  CardHeader,
  IconButton,
  Button,
  Grid,
  FormControl,
  MenuItem,
  FormGroup,
  Radio,
  Select,
  InputBase,
  Paper,
  createStyles,
  Theme,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { userStyles } from "../styles";
import { Error } from "@material-ui/icons";
import MyPATTextField from "../../common/MyPATTextField";
import MyPATDialog from "../../common/MyPATDialog";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import _ from "lodash";
import SearchBarWithChips from "../../course-Management/common/SearchBarWithChips";


interface AddUserDialogProps extends WithStyles<typeof userStyles> {
  getClientsWithoutPagination: any;
  getRolesListWithoutPagination: any;
  reportingToList: any;
  clientsList: any;
  subjectList: any;
  getSubjectList: any;
  dialogCloseHandler: () => void;
  addUser: any;
  formErrors: any;
  history: any;
  userAddedSuccessfully: any;
  user: any;
  isEdit: boolean;
  editUser: any;
  switchSelectedTab: any;
  setUsersTab: any;
  userEditedSuccessfully: boolean;
  addUserToastClose: any
}
interface AddUserDialogState {
  formData: any;
  userDetails: any;
  formErrors: any;
  isFormValid: any;
  isAdmin: any;
  isSuperAdmin: any;
  userPayload: any;
  clientsName: any;
  showDropdown: boolean;
  showStatusDropdown: boolean;
  subjectList: any;
  user: any;
  isActive: boolean;
  openResetPopup: boolean;
  showPrimaryDropdown: boolean;
  formDataReceived: any;
}
interface Subject {
  id: string;
  name: string;
}
class AddUserDialog extends Component<AddUserDialogProps, AddUserDialogState> {
  constructor(props: AddUserDialogProps) {
    super();
    this.state = {
      formData: {
        fullName: "",
        email: "",
        empCode: "",
        primaryClient: "",
        mobile: {
          countryCode: "+91",
          number: "",
        },
        subjectsExpert: [],
        isAssignTest: true,
        clientName: [],
        role: "",
        subjectName: "",
      },
      formDataReceived: {
        fullName: "",
        email: "",
        empCode: "",
        primaryClient: "",
        mobile: {
          countryCode: "+91",
          number: "",
        },
        subjectsExpert: [],
        isAssignTest: true,
        clientName: [],
        role: "",
        subjectName: "",
      },
      clientsName: [],
      subjectList: [],
      userDetails: {},
      formErrors: {
        name: "",
        role: "",
        fullName: "",
        email: "",
        empCode: "",
        number: ""
      },
      isFormValid: false,
      userPayload: {
        clients: [],
        role: "",
        fullName: "",
        email: "",
        empCode: "",
        mobile: {
          countryCode: "+91",
          number: "",
        },
        subjectsExpert: [],
        isAssignTest: true,
      },
      isAdmin: false,
      isSuperAdmin: false,
      showDropdown: false,
      showStatusDropdown: false,
      user: null,
      isActive: false,
      openResetPopup: false,
      showPrimaryDropdown: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.onAutoCompleteSubjectChange = this.onAutoCompleteSubjectChange.bind(
      this
    );
  }

  componentDidMount() {
    this.props.getClientsWithoutPagination();
    this.props.getSubjectList();
    // document.addEventListener('mousedown', this.handleClickOutside);
    const userD: any = ACLService.getUserDetailsFromStorage();
    this.setState({
      userDetails: userD,
      isAdmin:
        userD && userD.authenticatedUser && userD.authenticatedUser.isAdmin,
      isSuperAdmin:
        userD &&
        userD.authenticatedUser &&
        userD.authenticatedUser.isSuperAdmin,
    });
  }
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    return {
      user: nextProps.user,
    };
  }

  handleClosePopup() {
    this.setState({
      openResetPopup: false
    })
  }

  renderCustomDropdown() {
    const { classes, reportingToList } = this.props;
    const { showDropdown, formData } = this.state;
    return (
      <Grid className={classes.customDropdown}>
      <span
        className={[
          classes.variationSelect,
          ((this.state.formData.primaryClient === "") || 
          (this.props.isEdit && formData.role === "Admin" && formData.clientName && formData.clientName.length === 2))
            ? classes.disable
            : " ",
        ].join(" ")}
        onClick={this.handleDropdown}
      >
        <span className="selectBox">
          {this.state.formData.role
            ? this.state.formData.role
            : "Select Role"}
        </span>
        <span className={classes.arrowIcon}>
          <img src="/assets/svg/userManagement/arrowUP.svg" />
        </span>
      </span>
      {showDropdown && (
        <>
          <Grid className={classes.dropdownList}>
            <Grid>
              {reportingToList &&
                reportingToList.length !== 0 &&
                reportingToList.map((role: any) => {
                  if(role.role !== "Admin") {
                  return (
                    <>
                      <Grid
                        item
                        className={classes.listItem}
                        onClick={(e) => {
                          this.setReportingTo(role.role);
                        }}
                      >
                        {role.role}
                      </Grid>
                    </>
                  );
                  }
                })}
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
    )
  }
  renderCustomPrimaryDropdown() {
    const { classes, reportingToList } = this.props;
    const { showPrimaryDropdown, formData } = this.state;
    return (
      <Grid className={classes.customDropdown}>
      <span
        className={[
          classes.variationSelect,
          formData.clientName && (formData.clientName.length === 0 || formData.clientName.length === 1)
            ? classes.disable
            : " ",
        ].join(" ")}
        onClick={this.handlePrimaryDropdown}
      >
        <span className="selectBox">
          {formData.primaryClient
            ? formData.primaryClient
            : "Select Client/Org"}
        </span>
        <span className={classes.arrowIcon}>
          <img src="/assets/svg/userManagement/arrowUP.svg" />
        </span>
      </span>
      {showPrimaryDropdown && (
        <>
          <Grid className={classes.dropdownList}>
            <Grid>
              {formData &&
                formData.clientName.map((client: any) => {
                  return (
                    <>
                      <Grid
                        item
                        className={classes.listItem}
                        onClick={(e) => {
                          this.setClientName(client);
                        }}
                      >
                        {client.label}
                      </Grid>
                    </>
                  );
                })}
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
    )
  }
  renderCustomStatusDropdown() {
    const { classes } = this.props;
    const { showStatusDropdown } = this.state;
    return(
      <Grid item xs={6}>
      <Typography
        variant="body1"
        gutterBottom
        className={[
          classes.fontSize_SM,
          classes.black,
        ].join(" ")}
      >
        User Account Status{" "}
        <span className={classes.error}>*</span>
      </Typography>
      <Grid item className={classes.customDropdown}>
        <span
          className={[classes.variationSelect].join(" ")}
          onClick={this.handleStatusDropdown}
        >
          <span className="selectBox">
            {this.state.isActive ? "Active" : "Inactive"}
          </span>
          <span className={classes.arrowIcon}>
            <img src="/assets/svg/userManagement/arrowUP.svg" />
          </span>
        </span>
        {showStatusDropdown && (
          <>
            <Grid className={classes.dropdownList}>
              <Grid>
                {["Active", "Inactive"].map((ele: any) => {
                  return (
                    <>
                      <Grid
                        item
                        className={classes.listItem}
                        onClick={(e) => {
                          this.changeStatus(ele);
                        }}
                      >
                        {ele}
                      </Grid>
                    </>
                  );
                })}
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
    )
  }
  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.userDetails !== this.state.userDetails) {
      if (!this.state.isSuperAdmin) {
        let clientsName =
        this.state.userDetails &&
        this.state.userDetails.authenticatedUser &&
        this.state.userDetails.authenticatedUser.clients.map((ele: any) => (
          {
         id: ele.id,
         label: ele.name,
         value: ele.id
       }));
        if(clientsName.length > 1) { 
        this.setState((prevState: any) => ({
          clientsName: clientsName,
            formData: {
            ...prevState.formData,
            clientName: [],
          },
        }));
      } else {
        let clientsName =
        this.state.userDetails &&
        this.state.userDetails.authenticatedUser &&
        this.state.userDetails.authenticatedUser.clients.map((ele: any) => ele.name);
        this.setState((prevState: any) => ({
            formData: {
            ...prevState.formData,
            clientName: clientsName,
            primaryClient: clientsName
          },
          userPayload: {
            ...prevState.userPayload,
            clients: this.state.userDetails.authenticatedUser.clients
          }
        }));
        this.props.getRolesListWithoutPagination(
          this.state.userDetails.authenticatedUser.clients[0].id
        );
      }
      }
    }
    if (prevProps.clientsList !== this.props.clientsList && this.state.isSuperAdmin) {
      let clientsName =
        this.props.clientsList &&
        this.props.clientsList.clients &&
        this.props.clientsList.clients.map((ele: any) => (
          {
         id: ele._id,
         label: ele.name,
         value: ele._id
       }));
      this.setState({
        clientsName: clientsName,
      });
    }
    if (prevProps.subjectList !== this.props.subjectList) {
      let subjectListName =
        this.props.subjectList &&
        this.props.subjectList.map((ele: any) => (
          {
         id: ele._id,
         label: ele.name,
         value: ele._id
       }));
      this.setState({
        subjectList: subjectListName,
      });
    }
    if (prevProps.formErrors !== this.props.formErrors) {
      this.setState(
        {
          formErrors: this.props.formErrors,
        },
        () => {
          let formValid = this.validateForm(this.state.formErrors);
          this.setState((prevState: any) => ({
            isFormValid: formValid,
          }));
        }
      );
    }
    if (prevProps.userAddedSuccessfully !== this.props.userAddedSuccessfully) {
      this.props.history.push("/userManagement");
      this.props.switchSelectedTab("Users");
      this.props.setUsersTab(true);
    }
    if (prevState.user !== this.state.user) {
      this.setFormData(this.state.user);
    }
    if (prevProps.userEditedSuccessfully !== this.props.userEditedSuccessfully) {
      setTimeout( ()=> {
        this.props.addUserToastClose();
      }, 4000)
    }
  }
  setFormData = (userData: any) => {
    let clientsName =
    userData &&
    userData.clients.map((ele: any) => (
      {
     id: ele.id,
     label: ele.name,
     value: ele.id
   }));
    let primaryClient =
    userData &&
    userData.clients.filter((ele: any) => ele.primary === true );
    let formDataReceived = {
      fullName: userData.firstName
        ? userData.firstName + " " + userData.lastName
        : "",
      email: userData.email,
      empCode: userData.empCode,
      mobile: {
        countryCode: userData.mobile && userData.mobile.countryCode,
        number: userData.mobile && userData.mobile.number,
      },
      subjectsExpert: userData.subjectsExpert,
      isAssignTest: userData.isAssignTest,
      role: userData && userData.role && userData.role.role,
      clientName: clientsName,
      primaryClient: _.get(primaryClient, '[0].name', '')
    };
    let userPayloadData = {
      clients: userData && userData.clients,
      role: userData && userData.role && userData.role._id,
      fullName: userData.firstName
        ? userData.firstName + " " + userData.lastName
        : "",
      email: userData.email,
      empCode: userData.empCode,
      mobile: {
        countryCode: userData.mobile && userData.mobile.countryCode,
        number: userData.mobile && userData.mobile.number,
      },
      subjectsExpert: userData.subjectsExpert,
      isAssignTest: userData.isAssignTest,
      isActive: userData.isActive,
    };
    this.props.getRolesListWithoutPagination(
      _.get(primaryClient, '[0].id', '')
    );
    this.setState({
      formDataReceived,
      formData: formDataReceived,
      userPayload: userPayloadData,
      isActive: userData.isActive,
    });
  };
  validateForm(errors: any) {
    let valid = true;
    let validData = true;
    Object.values(errors).forEach(
      (val: any) => val.length > 0 && (valid = false)
    );
    if (
      this.state.userPayload.clients.length &&
      this.state.userPayload.role &&
      this.state.userPayload.fullName &&
      this.state.userPayload.email &&
      this.state.formData.primaryClient &&
      this.state.userPayload.empCode
    ) {
      validData = true;
    } else {
      validData = false;
    }
    return valid && validData;
  }
  checkEmailValidity = (email: string) => {
    let isEmailValid = true;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    isEmailValid = re.test(String(email).toLowerCase());
    if (isEmailValid) {
      return isEmailValid;
    } else {
      return false;
    }
  };
  changeStatus(value: any) {
    let formValid = this.validateForm(this.state.formErrors);
    this.setState((prevState: any) => ({
      formData: {
        ...prevState.formData,
      },
      userPayload: {
        ...prevState.userPayload,
        isActive: value === "Active" ? true : false,
      },
      isActive: value === "Active" ? true : false,
      showStatusDropdown: false,
      isFormValid: formValid,
    }));
  }
  checkmobileValidity = (mobile: string) => {
    let ismobileValid = true;
    if(mobile && mobile.length===0)
      return true;
    const allCountries = getCountryList();
    const country = allCountries.find(
      (country) =>
        country.dialCode === this.state.formData.mobile.countryCode
    );
    const pattern = country && country.regex ? country.regex : '';
    const regexObj = new RegExp(pattern);
    if (!regexObj.test(mobile)) {
      ismobileValid = false;
      return ismobileValid;
    } else {
      return true;
    }
  };
  handleChange(event: any) {
    let { name, value, checked } = event.target;
    let errors = this.state.formErrors;
    switch (name) {
      case "fullName":
        errors.fullName =
          value.length < 3 ? "Please enter at least 3 characters" : "";
        this.setState((prevState: any) => ({
          formData: {
            ...prevState.formData,
            fullName: value,
          },
          userPayload: {
            ...prevState.userPayload,
            fullName: value.trim(),
          },
        }));
        break;
      case "email":
        errors.email = !this.checkEmailValidity(value)
          ? "Please enter a valid email id."
          : "";
        this.setState((prevState: any) => ({
          formData: {
            ...prevState.formData,
            email: value,
          },
          userPayload: {
            ...prevState.userPayload,
            email: value,
          },
        }));
        break;
      case "number":
        errors.number = !this.checkmobileValidity(value)
        ? "Please enter a valid mobile number"
        : "";
        this.setState((prevState: any) => ({
          formData: {
            ...prevState.formData,
            mobile: {
              ...prevState.formData.mobile,
              number: value,
            },
          },
          userPayload: {
            ...prevState.userPayload,
            mobile: {
              ...prevState.userPayload.mobile,
              number: value,
            },
          },
        }));
        break;
      case "countryCode":
        errors.number = !this.checkmobileValidity(this.state.formData.mobile.number)
        ? "Please enter a valid mobile number"
        : "";
        this.setState((prevState: any) => ({
          formData: {
            ...prevState.formData,
            mobile: {
              ...prevState.formData.mobile,
              countryCode: value,
            },
          },
          userPayload: {
            ...prevState.userPayload,
            mobile: {
              ...prevState.userPayload.mobile,
              countryCode: value,
            },
          },
        }));
        break;
      case "empCode":
        errors.empCode = value.length < 5
          ? "Please enter a valid empCode."
          : "";
        this.setState((prevState: any) => ({
          formData: {
            ...prevState.formData,
            empCode: value,
          },
          userPayload: {
            ...prevState.userPayload,
            empCode: value,
          },
        }));
        break;
      case "test":
        this.setState((prevState: any) => ({
          formData: {
            ...prevState.formData,
            isAssignTest: checked,
          },
          userPayload: {
            ...prevState.userPayload,
            isAssignTest: checked,
          },
        }));
      default:
        break;
    }
    const formValid = this.validateForm(errors);
    this.setState({
      formErrors: errors,
      isFormValid: formValid,
    });
  }

  resetForm = () => {
    this.setState((prevState: any) => ({
      formData: {
        fullName: "",
        email: "",
        empCode: "",
        mobile: {
          countryCode: "+91",
          number: "",
        },
        subjectsExpert: [],
        isAssignTest: true,
        clientName: [],
        role: "",
        subjectName: "",
        primaryClient: ""
      },
      formErrors: {
        name: "",
        role: "",
        fullName: "",
        email: "",
        number: "",
        empCode: ""
      },
      isFormValid: false,
      userPayload: {
        clients: [],
        role: "",
        fullName: "",
        email: "",
        empCode: "",
        mobile: {
          countryCode: "+91",
          number: "",
        },
        subjectsExpert: [],
        isAssignTest: true,
      },
      openResetPopup: false

    }));
  };
  onAutoCompleteChange(selections: any[] | null) {
    let errors = this.state.formErrors;
    let updatedFormData = this.state.formData;
    if (selections && (selections.length === 0 || selections.length > 1)) {
      updatedFormData.role = "";
      updatedFormData.primaryClient = "";
    }
    const clientsList = (selections || []).map((client) => ({
      name: client.label,
      id: client.value,
      primary: selections && selections.length > 1 ? false : true
    }));
    this.setState((prevState: any) => ({
      userPayload: {
        ...prevState.userPayload,
        clients: clientsList,
      },
    }));    
    updatedFormData.clientName = selections;
    errors.name = selections && selections.length === 0 ? "This field is required" : "";

    let formValid = this.validateForm(errors);
    this.setState({
      formData: updatedFormData,
      formErrors: errors,
      isFormValid: formValid
    }, () => {
      if(selections && selections.length === 1) {
        let clientsList = this.state.userPayload.clients;
        clientsList[0].primary = true;
        this.setState((prevState: any) => ({
          formData: {
            ...prevState.formData,
            primaryClient: selections && selections[0].label,
            role: ""
          },
          userPayload: {
            ...prevState.userPayload,
            clients: clientsList,
          },
          showPrimaryDropdown: false,
        }))  
        this.props.getRolesListWithoutPagination(selections && selections[0].id);
  }
    });

  }
  handleSubmit = (event: any) => {
    event.preventDefault();
    if (this.validateForm(this.state.formErrors) && !this.props.isEdit) {
      this.props.addUser(this.state.userPayload);
    }
    if (this.validateForm(this.state.formErrors) && this.props.isEdit) {
      let data = {
        ...this.state.userPayload,
        userId: this.state.user._id,
      };
      if (this.state.formDataReceived.mobile) {
        delete data.mobile;
      }
      if (this.state.formDataReceived.email) {
        delete data.email;
      }
      this.props.editUser(data);
      this.setState({
        isFormValid: false
      })
    }
  };

  getTransformedValues = (subjects: Subject[]) => {
    return subjects && subjects.map((subject) => ({
      label: subject.name,
      id: subject.id,
      value: subject.id,
    }));
  };


  onAutoCompleteSubjectChange(selections: any[] | null) {
    const subjectsExpert = (selections || []).map((selection) => ({
      name: selection.label,
      id: selection.value,
    }));
    let formValid = this.validateForm(this.state.formErrors);
    this.setState((prevState: any) => ({
      formData: {
        ...prevState.formData,
        subjectsExpert: subjectsExpert,
      },
      userPayload: {
        ...prevState.userPayload,
        subjectsExpert: subjectsExpert,
      },
      isFormValid: formValid,
    }));
  }
  setClientName(primaryClient: any){
    let errors = this.state.formErrors;
    errors.role = "This field is required";
    errors.name = "";
      let clientData = JSON.parse(JSON.stringify(this.state.userPayload.clients))
      clientData = clientData.map((ele: any) => {
        if(ele.name === primaryClient.label) {
          ele.primary = true
        } else {
          ele.primary = false
        }
        return ele;
       })
      this.setState((prevState: any) => ({
        formData: {
          ...prevState.formData,
          primaryClient: primaryClient.label,
          role: ""
        },
        showPrimaryDropdown: false,
        isFormValid: false,
        formErrors: errors,
        userPayload: {
         ...prevState.userPayload,
         clients: clientData 
        }
      }))
      let id = primaryClient.id
      this.props.getRolesListWithoutPagination(id);
    
  }
  setReportingTo(value: any) {
    let errors = this.state.formErrors;
    let formValid: any;
    errors.role = value.length === 0 ? "This field is required" : "";
    const selectedReportingTo =
      this.props.reportingToList &&
      this.props.reportingToList.filter(function(role: any) {
        return role.role === value;
      });
    if (selectedReportingTo && selectedReportingTo.length) {
      this.setState(
        (prevState: any) => ({
          userPayload: {
            ...prevState.userPayload,
            role: selectedReportingTo[0]._id,
          },
        }),
        () => {
          formValid = this.validateForm(errors);
          this.setState((prevState: any) => ({
            isFormValid: formValid,
          }));
        }
      );
    }
    this.setState((prevState: any) => ({
      formData: {
        ...prevState.formData,
        role: value,
      },
      formErrors: errors,
      showDropdown: false,
      showStatusDropdown: false,
    }));
  }
  handleDropdown = () => {
    const { formData } = this.state;
    if((this.state.formData.primaryClient !== "") && !(this.props.isEdit && formData.role === "Admin" && formData.clientName && formData.clientName.length === 2)) {
    let errors = this.state.formErrors;
    errors.role =
      this.state.formData.role.length === 0 ? "This field is required" : "";

    this.setState({
      showDropdown: !this.state.showDropdown,
      formErrors: errors,
    });
  }
  };
  handlePrimaryDropdown = () => {
    if(this.state.formData.clientName && this.state.formData.clientName.length !== 0 && this.state.formData.clientName.length !== 1) {
      this.setState({
        showPrimaryDropdown: !this.state.showPrimaryDropdown,
      });
    }
  };
  handleDropdownClose = () => {
    this.setState({
      showDropdown: false,
      showPrimaryDropdown: false
    });
  };
  handleStatusDropdown = () => {
    this.setState({
      showStatusDropdown: !this.state.showStatusDropdown,
    });
  };
  handleStatusDropdownClose = () => {
    this.setState({
      showStatusDropdown: false,
    });
  };
  handleToaster = () => {
    this.props.addUserToastClose();
  };
  getCountryItemsList = () => {
    const countryList = getCountryList();
    const { classes } = this.props;

    const countryListMenuItems = countryList.map((country: any, index: any) => {
      return (
        <MenuItem
          key={index}
          value={`${country.dialCode}`}
          className={classes.menuItem}
        >
          <img src={`${country.flag}`} />
          {country.dialCode}
        </MenuItem>
      );
    });

    return countryListMenuItems;
  };
  render() {
    const countryListItems = this.getCountryItemsList();
    const { classes, reportingToList, dialogCloseHandler } = this.props;
    const { showDropdown, showStatusDropdown, showPrimaryDropdown, userDetails } = this.state;
    return (
      <>
              {this.props.userEditedSuccessfully && (
          <Grid
            className={[classes.customToaster, classes.successTooltip].join(
              " "
            )}
          >
            <Typography variant="h6">
              <span>
                <CheckCircleIcon />
              </span>
              <span>User Updated Successfully</span>
              <span className="closeIcon" onClick={this.handleToaster}>
                <CloseIcon />
              </span>
            </Typography>
          </Grid>
        )}
        <Modal
          BackdropProps={{ invisible: true }}
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          hideBackdrop={true} //@Neeraj: try to follow the Material UI doc for UI Arch
          className={[
            classes.fontSizeLG,
            classes.fontWeight500,
            classes.modal,
          ].join(" ")}
          open={true}
        >
          <div className={classes.paper}>
            <Card elevation={0}>
              <DialogHeader
                urlName="/userManagement"
                selectedTab="Users"
                iconNode={
                  <IconButton
                    aria-label="settings"
                    onClick={dialogCloseHandler}
                  >
                    <CloseIcon className={classes.fontSizeLG} />
                  </IconButton>
                }
                headerTitle={this.props.isEdit ? "Edit User" : "Add New User"}
              />

              <CardContent className={classes.cardContentStyle}>
                <Grid>
                  <Card
                    className={[classes.CustomCard, classes.overflowAuto].join(
                      " "
                    )}
                  >
                    <Grid container spacing={8} alignItems="flex-start">
                      <Grid item xs={4}>
                        <Grid
                          className={[
                            classes.roleFormElement,
                            classes.customInputBox,
                          ].join(" ")}
                        >
                          <Typography
                            variant="body1"
                            gutterBottom
                            className={[
                              classes.fontSize_SM,
                              classes.black,
                              // classes.clientTitle,
                            ].join(" ")}
                          >
                            Select Client/Org.
                          </Typography>
                          <Grid className={classes.autoCompleteBox}>
                            {_.get(userDetails, 'authenticatedUser.clients', []).length === 1 && !this.state.isSuperAdmin && (
                              <input
                                type="text"
                                name="name"
                                className={classes.customDisabled}
                                placeholder="Enter Client Name."
                                value={this.state.formData.clientName && (this.state.formData.clientName[0] && this.state.formData.clientName[0].label || this.state.formData.clientName[0])}
                                disabled
                              />
                            )}
                            {(_.get(userDetails, 'authenticatedUser.clients', []).length > 1 || this.state.isSuperAdmin) && (
                              <SearchBarWithChips
                                suggestions={this.state.clientsName}
                                onSelection={this.onAutoCompleteChange.bind(this)}
                                values={this.state.formData.clientName}
                                placeholder="Search and Select Client"
                                notFound="No client found."
                                classes={{ root: classes.searchBarChips }}
                              />

                            )}
                          </Grid>
                           {
                            this.state.formErrors.name.length > 0 && (
                              <Typography className={classes.errorText}>
                                <Error /> {this.state.formErrors.name}
                              </Typography>
                            )}
                        </Grid>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={[classes.fontSize_SM, classes.black].join(
                            " "
                          )}
                        >
                          Set Primary Client/Org.
                        </Typography>
                        { showPrimaryDropdown && (
                        <ClickAwayListener
                        onClickAway={this.handleDropdownClose}> 
                          {this.renderCustomPrimaryDropdown()}
                        </ClickAwayListener>
                        )}
                        { !showPrimaryDropdown && (
                          this.renderCustomPrimaryDropdown()
                        )}
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={[classes.fontSize_SM, classes.black].join(
                            " "
                          )}
                        >
                          Select Role <span className={classes.error}>*</span>
                        </Typography>
                        { showDropdown && (
                        <ClickAwayListener
                        onClickAway={this.handleDropdownClose}> 
                          {this.renderCustomDropdown()}
                        </ClickAwayListener>
                        )}
                        { !showDropdown && (
                          this.renderCustomDropdown()
                        )}

                        {this.state.formErrors.role.length > 0 && (
                          <Typography className={classes.errorText}>
                            <Error /> {this.state.formErrors.role}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                    <br/>
                    <Grid container spacing={8} alignItems="center">
                      <Grid item xs={6}>
                        <Grid className={classes.roleFormElement}>
                          <Typography
                            variant="body1"
                            gutterBottom
                            className={[
                              classes.fontSize_SM,
                              classes.black,
                            ].join(" ")}
                          >
                            Subject
                            <CustomInfoIcon
                              isInfoIcon={true}
                              isCenterArrow={true}
                              isRightArrow={false}
                              knowMoreAbout={false}
                              dialogTitle="Subject"
                              imageURL="/assets/svg/infoIcon/subject.svg"
                              dialogPara="This field helps identify the subject(s) that the user has knowledge of. It does not affect any other permission given to the user. Users will be able to access the content for all subjects irrespective of what you add in their profile "
                              toolTipDirection="top"
                              details="Click to know more"
                            />
                          </Typography>
                          <Grid
                            className={[
                              classes.autoCompleteBox,
                              classes.customInputBox,
                              // classes.newAutoComplete,
                            ].join(" ")}
                          >
                            <SearchBarWithChips
                              suggestions={this.state.subjectList}
                              onSelection={this.onAutoCompleteSubjectChange}
                              values={this.getTransformedValues(this.state.formData.subjectsExpert)}
                              placeholder="Search and Select subjects"
                              notFound="No subject found."
                              classes={{ root: classes.searchBarChips }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      {this.props.isEdit && ( <>
                        { showStatusDropdown && (
                          <ClickAwayListener 
                           onClickAway={this.handleStatusDropdownClose}>
                           {this.renderCustomStatusDropdown()}
                          </ClickAwayListener>)}
                                  
                        { !showStatusDropdown && (
                            this.renderCustomStatusDropdown()
                       )}
                        </>

                      )}
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={[classes.fontSize_SM, classes.black].join(
                            " "
                          )}
                        >
                          Assign Test
                        </Typography>
                        <FormControlLabel
                          className={[
                            classes.customRadio,
                            classes.marginZero,
                            classes.marginB20,
                          ].join(" ")}
                          control={
                            <Checkbox
                              checked={this.state.formData.isAssignTest}
                              classes={{
                                root: classes.checkbox,
                                checked: classes.checkedCheckbox,
                                colorPrimary: classes.primaryColor,
                              }}
                              onChange={this.handleChange}
                              color="primary"
                              disableRipple
                            />
                          }
                          label="Allow"
                          name="test"
                          classes={{
                            label: [classes.fontSize_SM, classes.grey].join(
                              " "
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Card>

                  <Grid>
                    <Typography className={classes.CardTitle}>
                      Basic Details
                    </Typography>
                  </Grid>
                  <Card className={classes.CustomCard}>
                    <Grid container spacing={8} alignItems="center">
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Name <span className={classes.error}>*</span>
                        </Typography>
                        <Grid className={classes.customInputBox}>
                          <input
                            type="text"
                            name="fullName"
                            className="myPatTextField"
                            placeholder="Enter Name."
                            value={this.state.formData.fullName}
                            onChange={this.handleChange}
                          />
                        </Grid>
                        {this.state.formErrors.fullName.length > 0 && (
                          <Typography className={classes.errorText}>
                            <Error /> {this.state.formErrors.fullName}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Email ID <span className={classes.error}>*</span>
                        </Typography>
                        <Grid className={classes.customInputBox}>
                          <input
                            type="text"
                            name="email"
                            className={(this.props.isEdit && this.state.formDataReceived.email && this.state.formDataReceived.email.length) ? classes.customDisabled : ''}
                            placeholder="Enter Email ID"
                            value={this.state.formData.email}
                            onChange={this.handleChange}
                          />
                        </Grid>
                        {this.state.formErrors.email.length > 0 && (
                          <Typography className={classes.errorText}>
                            <Error /> {this.state.formErrors.email}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container spacing={8} alignItems="center">
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Contact <span className={classes.error}>*</span>
                        </Typography>
                        <div className={classes.flagContainerNew}>
                          <FormControl>
                            <Select
                              value={this.state.formData.mobile.countryCode}
                              onChange={(e) => this.handleChange(e)}
                              displayEmpty
                              name="countryCode"
                              disableUnderline={true}
                              classes={{ root: classes.customSelect }}
                              className={(this.props.isEdit && this.state.formDataReceived.mobile.countryCode && this.state.formDataReceived.mobile.countryCode.length) ? classes.customDisabled : ''}
                            >
                              {countryListItems}
                            </Select>
                          </FormControl>
                          {/* <Grid className={classes.customInputBox}> */}
                          <MyPATTextField
                            type="number"
                            name="number"
                            endAdornment={<span></span>}
                            placeholder="Enter Contact No"
                            value={this.state.formData.mobile.number}
                            onChange={this.handleChange}
                            className={[
                              classes.customInput,
                              classes.inputWidth,
                              (this.props.isEdit && this.state.formDataReceived.mobile.number && this.state.formDataReceived.mobile.number.length) ? classes.customDisabled : ''
                            ].join(" ")}
                            error={this.state.formErrors.number.length > 0 }
                            errorText={
                              this.state.formErrors.number
                            }
                          />
                          {/* </Grid> */}
                        </div>
                      </Grid>
                      {this.props.isEdit && this.state.formData.empCode ? <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Emp Code <span className={classes.error}>*</span>
                        </Typography>
                        <Grid className={classes.customInputBox}>
                          <input
                            type="text"
                            name="empCode"
                            className={classes.customDisabled}
                            placeholder="Enter Emp Code"
                            value={this.state.formData.empCode}
                          />
                        </Grid>
                      </Grid> : null
                      }

                      {!this.props.isEdit ? <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                          Emp Code <span className={classes.error}>*</span>
                        </Typography>
                        <Grid className={classes.customInputBox}>
                          <input
                            type="text"
                            name="empCode"
                            className="myPatTextField"
                            placeholder="Enter Emp Code"
                            maxLength={5}
                            value={this.state.formData.empCode}
                            onChange={this.handleChange}
                          />
                        </Grid>
                        {this.state.formErrors.empCode.length > 0 && (
                          <Typography className={classes.errorText}>
                            <Error /> {this.state.formErrors.empCode}
                          </Typography>
                        )}
                      </Grid> : null}
                    </Grid>
                  </Card>
                {/* </form> */}
                <MyPATDialog
                  dialogOpen={this.state.openResetPopup}
                  dialogHasActions={true}
                  dialogHeading={<Typography className={classes.resetHeading}>Reset Confirmation</Typography>}
                  isAlignCenter={true}
                  customButtonVariant="withoutBorderCloseIcon"
                  isCustomBackground={false}
                  onDialogClose={this.handleClosePopup.bind(this)}
                  isborderDialogAction={true}
                  customDialogActions={
                    <>
                      <Grid
                        container
                        justify="flex-end"
                        alignItems="flex-end"
                      >
                        <Button className={[classes.resetButton, classes.resetButtonEdit].join(' ')} 
                        onClick={this.handleClosePopup.bind(this)}
                        color="primary">No</Button>
                        <Button variant="contained"
                        onClick={this.resetForm.bind(this)}
                        color="primary">Yes</Button>
                      </Grid>
                    </>
                  }
                >
                  <Grid container className={classes.restDialogCotent}>
                  <Typography align="center">
                    Upon clicking reset, all the values will disappear. <br />
                    Are you sure, you want to reset all the values ?
                  </Typography>
                  </Grid>

                </MyPATDialog>
                </Grid>
              </CardContent>

              <DialogFooter
                htmlElements={
                  <>
                    {!this.props.isEdit && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.resetButton}
                        type="submit"
                        onClick={() => {
                          this.setState({
                            openResetPopup: true
                          })
                        }}
                      >
                        Reset
                      </Button>
                    )}

                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.btnCreateGoal}
                      type="submit"
                      disabled={!this.state.isFormValid}
                      onClick={this.handleSubmit}
                    >
                      {this.props.isEdit ? "Update User" : "Add User"}
                    </Button>
                  </>
                }
              />
            </Card>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  clientsList: state.clientManagement.rolesManagement.clientsList,
  reportingToList: state.clientManagement.rolesManagement.reportingTo.roleData,
  subjectList: state.clientManagement.usersManagement.subjectList,
  formErrors: state.clientManagement.usersManagement.formErrors,
  userAddedSuccessfully:
    state.clientManagement.usersManagement.userAddedSuccessfully,
  userEditedSuccessfully: state.clientManagement.usersManagement.userEditedSuccessfully
});

const mapDispatchToProps = {
  getClientsWithoutPagination,
  getRolesListWithoutPagination,
  getSubjectList,
  addUser,
  editUser,
  switchSelectedTab,
  setUsersTab,
  addUserToastClose
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(AddUserDialog)));
AddUserDialog;
